module.exports = __webpack_public_path__ + "img/divider2.4b489955.jpeg";